/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  In this files we configured router and menubar details
  #MenuLayout     : In this menulayout we mapped all our 
  #BrowserRouter  : BrowserRouter is a router implementation that uses the HTML5 history API (pushstate, replacestate, and popstate events) to keep your UI in sync with the URL.
                    It is the parent component used to store all other components.
  #RecoilRoot     : Recoil used to manage the global state value(s)
*/

import React, { useState, useRef, useContext, useEffect } from 'react'
import './App.css'
import { RecoilRoot } from 'recoil'
import ErrorBoundary from '../views/components/custom/errorBoundary/ErrorBoundary'
import DpsButton from '../views/components/base/button/DpsButton'
import ChallengeOverview from '../views/components/custom/challengeoverview/ChallengeOverview'
import DpsTextBox from '../views/components/base/textBox/DpsTextBox'
import CasevalidationDetails from '../views/components/custom/caseValidationDetails/CasevalidationDetails'
import { useAuthStore } from '../store/useStore'
import { LicenseInfo } from '@mui/x-license'
import AppConfigContext from './AppConfigContext'
import { exportDataGridToCsv } from '../views/utills/utils'

function App() {
  const [sliderstate, setSliderstate] = useState(false)
  const [pcnActions, setPcnActions] = useState({
    holdPcn: false,
    cancelPcn: false,
    offHold: false,
    swapPcn: false,
  })
  const [viewDetails, setViewDetails] = useState({
    vrm: false,
    make: false,
    corres: false,
    ceo: false,
  })
  const [isPcnStatusChanged, setIsPcnStatusChanged] = useState(false)
  const [isViewChallengeEditable, setIsViewChallengeEditable] = useState(true)
  const [viewDashBoard, setViewDashBoard] = useState(false)
  const [pcnNumber, setPcnNumber] = useState('')
  const [token, setToken] = useState('')
  const [caseDetails, setCaseDetails] = useState([])
  const { setAuth, bearer } = useAuthStore()
  const config = useContext(AppConfigContext)
  const appConfig = config?.appConfig || config // fallback if config is appConfig itself
  const licenseKey = appConfig?.VariableSettings?.MUIGridKey
  const [exportData, setExportData] = useState(false)
  const [correspondanceData, setCorrespondanceData] = useState([
    { ceoFilesToShow: [], backOfficeFilesToShow: [], citizenFilesToShow: [] },
  ])
  const [isAiraEnabled, setIsAiraEnabled] = useState(false)
  const handleOpenPanel = () => {
    if (pcnNumber.trim() !== '' && token.trim() !== '') {
      setAuth({ bearer: token, idToken: null }) // ✅ set token
      setSliderstate(true) // open the side panel
    } else {
      alert('Please enter both PCN Number and Token')
    }
  }

  const handleOpenDashBoard = () => {
    if (pcnNumber.trim() !== '' && token.trim() !== '') {
      setAuth({ bearer: token, idToken: null }) // ✅ set token
      setViewDashBoard(true) // open the dashboard
    } else {
      alert('Please enter both PCN Number and Token')
    }
  }

  const handleViewCaseInfo = (pcnNumber) => {
    console.log('view case', pcnNumber)
  }
  const handleCheckNumberOfNotes = (caseNumber) => {
    console.log('check number of case', caseNumber)
  }
  const handleCheckNumberOfCorrespondance = (caseNumber) => {
    console.log('check number of case', caseNumber)
  }

  LicenseInfo.setLicenseKey(licenseKey)
  useEffect(() => {
    console.log('view details', viewDetails)
    console.log('case details', caseDetails)
    console.log('pcn actions', pcnActions)
    console.log('correspondanceData', correspondanceData)
  }, [viewDetails, caseDetails, pcnActions, correspondanceData])
  const addNotesDialogProps = {}
  const cancelPcnDialogProps = {}
  const holdPcnDialogProps = {}
  const offHoldPcnDialogProps = {}
  useEffect(() => {
    console.log(pcnActions)
  }, [pcnActions])

  const handleDownloadCsv = () => {
    const dummyData = [
      {
        id: 1,
        date: '2026-02-23T04:52:08.989',
        pcnNumber: 'QA0050371A',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'CEO inputted incorrectly ',
        valid: 'Unknown',
      },
      {
        id: 2,
        date: '2026-02-23T04:52:02.008',
        pcnNumber: 'QA0050371A',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'AI/Bot Misread',
        valid: 'Unknown',
      },
      {
        id: 3,
        date: '2026-02-23T04:51:53.784',
        pcnNumber: 'QA0050371A',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'CEO inputted incorrectly ',
        valid: 'Unknown',
      },
      {
        id: 4,
        date: '2026-02-20T10:13:31.431',
        pcnNumber: 'QA0050371A',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'AI/Bot Misread',
        valid: 'Unknown',
      },
      {
        id: 5,
        date: '2026-02-20T10:13:25.964',
        pcnNumber: 'QA0050371A',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'CEO inputted incorrect Make ',
        valid: 'Unknown',
      },
      {
        id: 6,
        date: '2026-02-20T10:00:31.659',
        pcnNumber: 'QA0050371A',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'CEO inputted incorrectly ',
        valid: 'Yes',
      },
      {
        id: 7,
        date: '2026-02-20T10:00:31.659',
        pcnNumber: 'QA0050371A',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'CEO inputted incorrect Make ',
        valid: 'Yes',
      },
      {
        id: 8,
        date: '2026-02-20T09:58:31.678',
        pcnNumber: 'QA00503899',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'ANPR Misread Make',
        valid: 'Unknown',
      },
      {
        id: 9,
        date: '2026-02-20T09:57:25.138',
        pcnNumber: 'QA00503764',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'CEO inputted incorrectly ',
        valid: 'Unknown',
      },
      {
        id: 10,
        date: '2026-02-20T09:50:12.788',
        pcnNumber: 'QA00503764',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'CEO inputted incorrectly ',
        valid: 'Unknown',
      },
      {
        id: 11,
        date: '2026-02-19T13:51:48.469',
        pcnNumber: 'QA00503899',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'CEO inputted incorrect Colour',
        valid: 'Unknown',
      },
      {
        id: 12,
        date: '2026-02-19T11:31:01.345',
        pcnNumber: 'QA00503899',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'ANPR Misread Make',
        valid: 'Yes',
      },
      {
        id: 13,
        date: '2026-02-18T10:27:13.654',
        pcnNumber: 'QA00378469',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'VRM has been tampered with',
        valid: 'Unknown',
      },
      {
        id: 14,
        date: '2026-02-18T10:26:23.777',
        pcnNumber: 'QA00378469',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'ANPR Misread',
        valid: 'Unknown',
      },
      {
        id: 15,
        date: '2026-02-18T10:20:25.89',
        pcnNumber: 'QA00378469',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'CEO inputted incorrectly ',
        valid: 'Unknown',
      },
      {
        id: 16,
        date: '2026-02-18T09:45:29.338',
        pcnNumber: 'QA00378469',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'AI/Bot Misread',
        valid: 'Unknown',
      },
      {
        id: 17,
        date: '2026-02-18T07:15:59.958',
        pcnNumber: 'QA00503662',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'AI/Bot Misread Make & Colour',
        valid: 'Unknown',
      },
      {
        id: 18,
        date: '2026-02-18T07:15:17.807',
        pcnNumber: 'QA00503662',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'CEO inputted incorrect Make & Colour',
        valid: 'Unknown',
      },
      {
        id: 19,
        date: '2026-02-18T07:07:17.162',
        pcnNumber: 'QA00503662',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'AI/Bot Misread Make & Colour',
        valid: 'Unknown',
      },
      {
        id: 20,
        date: '2026-02-17T15:26:43.466',
        pcnNumber: 'QA00503640',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'AI/Bot Misread Make',
        valid: 'Unknown',
      },
      {
        id: 21,
        date: '2026-02-17T15:19:40.459',
        pcnNumber: 'QA00503640',
        agentName: 'user1',
        validation: 'MakeAndColor',
        notes: 'AI/Bot Misread Make',
        valid: 'Unknown',
      },
      {
        id: 22,
        date: '2026-02-17T15:17:33.706',
        pcnNumber: 'QA00378469',
        agentName: 'user1',
        validation: 'VRM',
        notes: 'VRM has been tampered with',
        valid: 'Yes',
      },
    ]

    exportDataGridToCsv({
      fileName: 'validation_data',
      dateFields: ['date'],
      rowsData: dummyData,
    })
  }
  return (
    <ErrorBoundary>
      <RecoilRoot>
        {!viewDashBoard && (
          <>
            <div className="Titlebar">
              <p className="title">Summarisation Stage II</p>
            </div>

            <div className="login-container">
              <div className="login-card">
                <div className="login-card-title">
                  Summarisation Stage II Login
                </div>

                <DpsTextBox
                  label="PCN Number"
                  placeholder="Enter PCN Number"
                  value={pcnNumber}
                  onchangeHandler={(e) => {
                    sessionStorage.setItem('pcnNumber', e.target.value)
                    setPcnNumber(e.target.value)
                  }}
                />
                <DpsTextBox
                  label="Token"
                  placeholder="Enter Token"
                  value={token}
                  onchangeHandler={(e) => {
                    setToken(e.target.value)
                  }}
                />
                <div className="access-button-wrapper">
                  <DpsButton
                    buttonVariant="contained"
                    buttonType="primary"
                    label="view challenge"
                    onClick={handleOpenPanel}
                  />
                  <DpsButton
                    buttonVariant="contained"
                    buttonType="primary"
                    label="Download CSV"
                    onClick={handleDownloadCsv}
                  />
                  <DpsButton
                    buttonVariant="contained"
                    buttonType="primary"
                    label="Challenge Overview"
                    onClick={handleOpenDashBoard}
                  />
                </div>
              </div>
            </div>
            <CasevalidationDetails
              sliderstate={sliderstate}
              setSliderstate={setSliderstate}
              setPcnNumber={setPcnNumber}
              setToken={setToken}
              pcnNumber={pcnNumber}
              token={token}
              handleViewCaseInfo={handleViewCaseInfo}
              handleCheckNumberOfNotes={handleCheckNumberOfNotes}
              handleCheckNumberOfCorrespondance={
                handleCheckNumberOfCorrespondance
              }
              AddNotesDialog={''}
              addNotesDialogProps={addNotesDialogProps}
              CancelPcnDialogBox={''}
              cancelPcnDialogProps={cancelPcnDialogProps}
              HoldPcnDialogBox={''}
              holdPcnDialogProps={holdPcnDialogProps}
              OffHoldPcnDialogBox={''}
              offHoldPcnDialogProps={offHoldPcnDialogProps}
              setCaseDetails={setCaseDetails}
              viewDetails={viewDetails}
              setViewDetails={setViewDetails}
              pcnActions={pcnActions}
              setPcnActions={setPcnActions}
              caseDetails={caseDetails}
              isPcnStatusChanged={isPcnStatusChanged}
              isViewChallengeEditable={isViewChallengeEditable}
              setCorrespondanceData={setCorrespondanceData}
              correspondanceData={correspondanceData}
              isAiraEnabled={isAiraEnabled}
            />
          </>
        )}
        {viewDashBoard && (
          <ChallengeOverview
            token={token}
            GridComponent={''}
            gridProps={''}
            GridPageSizeComponent={''}
            GridPageSizeProps={''}
            MultiSelectDateTimepicker={''}
            startDateProps={''}
            endDateProps={''}
            exportData={exportData}
            isDatesValid={''}
            contractId={contractId}
          />
        )}
      </RecoilRoot>
    </ErrorBoundary>
  )
}

export default App
